export const JOURNEY_CARDS = [
  {
    label: 'Doctor Signup',
    link: RedirectConfig.prescriberWebappSignup,
    image: '/images/cards/nurse.png',
  },
  {
    label: 'Pharmacy Signup',
    link: `mailto:${ContactConfig.email}`,
    image: '/images/cards/board.png',
  },
];
